var assetsTable = null;
var initialAmount = 10;
var totalAmount = 20;
//shareholdersTable.find('tbody tr:nth-last-child(-n+'+(totalAmount-initialAmount)+')').hide();

jQuery(document).ready(function () {

    if (isOnScreen(jQuery("#assets-portfolio-operation"))) {
        assetsTable = $("#assets-portfolio-operation");
        runAssets("first-part", "#assets-portfolio-operation");
    } else {
        window.addEventListener("scroll", function (e) {
            assetsTable = $("#assets-portfolio-operation");
            if (isOnScreen(jQuery("#assets-portfolio-operation"))) {
                /* Pass element id/class you want to check */
                runAssets("first-part", "#assets-portfolio-operation");
            }
        });
    }
    if (isOnScreen(jQuery("#assets-portfolio-construction"))) {
        assetsTable = $("#assets-portfolio-construction");
        runAssets("first-part", "#assets-portfolio-construction");
    } else {
        window.addEventListener("scroll", function (e) {
            if (isOnScreen(jQuery("#assets-portfolio-construction"))) {
                /* Pass element id/class you want to check */
                assetsTable = $("#assets-portfolio-construction");
                runAssets("first-part", "#assets-portfolio-construction");
            }
        });
    }
    if (isOnScreen(jQuery("#assets-portfolio-backlog"))) {
        assetsTable = $("#assets-portfolio-backlog");
        runAssets("first-part", "#assets-portfolio-backlog");
    } else {
        window.addEventListener("scroll", function (e) {
            assetsTable = $("#assets-portfolio-backlog");
            if (isOnScreen(jQuery("#assets-portfolio-backlog"))) {
                /* Pass element id/class you want to check */
                runAssets("first-part", "#assets-portfolio-backlog");
            }
        });
    }

    document.addEventListener('aos:in:super-duper', ({ detail }) => {
        console.log('animated in', detail);
    });
});

//optional param animateThese: "last-part" || "first-part"
function runAssets(animateThese, id) {
    var shareholders;

    if (
        animateThese === "first-part" &&
        assetsTable.find(id + "tbody tr:last-child").is(":hidden")
    )
        shareholders = assetsTable.find("tbody tr").slice(0, initialAmount);
    else if (animateThese === "last-part") {
        shareholders = assetsTable.find(
            "tbody tr:nth-last-child(-n+" + (totalAmount - initialAmount) + ")"
        );
        shareholders.fadeIn();
    } else {
        shareholders = assetsTable.find("tr");
    }

    var maxPercentage = 1500; // get the one with highest percentage
    
    // find the maximum percentage
    shareholders.each(function (i, val) {
        var bar = $(val).find(".bar");
        if (bar.length) {
            var percentage = bar.data("percentage");
            if (percentage > maxPercentage) {
                maxPercentage = percentage;
                console.log("maxPercentage", maxPercentage);
            }
        }
    });

    shareholders.each(function (i, val) {
        var bar = $(val).find(".bar");
        if (bar.length) {
            var percentage = bar.data("percentage");
            var x = 0.0;

            var becomeWidthSize = 100 * (percentage / maxPercentage);

            var span = bar.find("span");
            setTimeout(function () {
                span.animate(
                    {
                        width: becomeWidthSize + "%"
                    },
                    {
                        duration: 2000
                        //easing: 'easeOutCubic'
                    }
                );
            }, i * 75 + 300);
        }
    });
}

function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
        return;
    }
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;

    return (
        (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height &&
            top <= viewport_top &&
            bottom >= viewport_bottom)
    );
}